// extracted by mini-css-extract-plugin
module.exports =  {"unit":"var(--ring-unit)","pageWithSidebar":"PipelineTab__pageWithSidebar--BI","main":"PipelineTab__main--Wd","openSidebar":"PipelineTab__openSidebar--lp"};